import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Accordion, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { androidstore, appstore, bottomcard,  contentimg,  ctlogo, homeBg, homeCard1, homeCard2, iPhone14, safesecure, sustainshop } from "shared/images/images";
import { ItemsService } from "shared/services";
import { ADSENSE, NEWSANDSTORIESID } from "shared/settings/config";
import { getMaintainData, homeState } from "shared/settings/stateMaintain";
import { Adsense } from "shared/utils/Adsense";
import { addDataLayer, getItemUrl, setItemPreviousNextInSessionStorage } from "shared/utils/utils";
import CategoryList from "../public/HOC/CategoryList";
import ItemCard from "../public/HOC/ItemCard";
import ItemCardBoard from "../public/HOC/ItemCardBoard";
import PaginationHOC from "../public/HOC/PaginationHOC";
import store from "features/store";
import "./Home.scss"
import { isAuthorized } from "shared/settings/auth";
import MultiListPage from "../public/HOC/MultiListPagination";
import { SALE_LIST_TYPE, SaleListHoc } from "../public/HOC/SaleListHoc";
import { APP_STORE_URL, PLAY_STORE_URL } from 'shared/settings/config';
import { Helmet } from "react-helmet";
import { cirecleTick } from "shared/assets/icons";
import { bidEventManager } from "shared/sse/SSEManager";
const accordionData = [
    {
        img: ctlogo,
        color: "ctbids-dark"
    },
    {
        img: sustainshop,
        color: "teal"
    },
    {
        img: safesecure,
        color: "steel-dark"
    }
]
export default function Home(props) {
    const userData = useSelector(state => state?.user);
    const multilist = useSelector(state => state?.featureItemList);
    const homebanner = useSelector(state => state?.homebanner);
    const [trendingItem, settrendingItem] = useState([])
    const [endingSoonItem, setendingSoonItem] = useState([])
    // const [featureItems, setfeatureItems] = useState([])
    const [watchlist, setwatchlist] = useState([])
    const [currentBid, setcurrentBid] = useState([])
    const [activeKey, setActiveKey] = useState('0');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [homeItemIds, setHomeItemIds] = useState([]);


    useEffect(() => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (scrollContainer) {
            scrollContainer.scrollTop = 0;
        } else {
            window.scrollTo(0, 0);
        }
        store.dispatch({
            type: 'PUSH_TO_STATE', payload: {}
        });
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        getRequiredData()

        return () => {
            window.removeEventListener('resize', handleResize);
            bidEventManager.ignore();
        }
    }, [])
    useEffect(() => {
        if (userData.id) {
            getWatchList(homeItemIds)
        } else {
            setwatchlist([])
        }
    }, [userData.id])


    const getRequiredData =  () => {
        // const previous = getMaintainData(previousState);
        Promise.all([getTrendingItem(), getEndingSoonItem()]).then(async (responses) => {
            if (responses[0]?.length > 0 || responses[1]?.length > 0) {
                let itemids = [...responses[0], ...responses[1]].map(item => item.id ? item.id : item.itemid)
                if (userData.id) {
                    getWatchList(itemids)
                }
                setHomeItemIds(itemids)
                getBidValues(itemids);
                
                bidEventManager.connect(itemids);
            }
            settrendingItem(responses[0])
            setendingSoonItem(responses[1])
            // setfeatureItems(responses[2])
            // timeIntervel = setInterval(() => {
            //     Promise.all([ getFeaturedItem()]).then(async (responses) => {
            //         setfeatureItems(responses[0])
            //     });
            // }, 10000);
        });

    }
    const redirectSignin = () => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
    }
    const getPreviousValues = () => {
        const temp = getMaintainData(homeState);
    }
    const recallwatchlist = () => {
        let itemids = [...trendingItem, ...endingSoonItem].map(item => item.id ? item.id : item.itemid)
        getWatchList(itemids)
    }
    const getWatchList = (ids) => {
        const data = {
            "sort": [{ "field": "id", "direction": "desc" }],
            "filter": [{ "field": "itemid", "value": [ids], "op": "IN", "join": "AND" }],
            "field": ["itemid"],
        };
        ItemsService.getWatchListItem(data).then(
            response => {
                setwatchlist(response.data.data)

            }
        ).catch(error => {
        });
    }
    const getBidValues = (ids) => {
        const data = {
            "data": {
                "itemIds": ids
            }
        };
        ItemsService.getCurrentBidValue(data).then(
            response => {
                setcurrentBid(response.data.data)
            }
        ).catch(error => {
        })
    }
    
    const getTrendingItem = () => {
        const payload = {
            "sort": [{ "field": "bidcount", "direction": "desc" }],
            "page": { "size": 4 },
            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", "categoryGroup", "thumbnailurl", "itemseourl", "bidcount"],
            "filter": [
                { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" }
            ]
        };
        return new Promise((resolve, reject) => {
            ItemsService.getItemsList(payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }
    // const getFeaturedItem = () => {
    //     const payload = {
    //         "sort": [{ "field": "id", "direction": "asc" }],
    //         "field": ["itemid", "title", "itemdisplayurl", "itemtypeid", "status","saleid","itemseourl"],
    //     };
    //     return new Promise((resolve, reject) => {
    //         ItemsService.getshopwithItemList(payload).then(response => {
    //             resolve(response.data.data);
    //         }).catch((error) => {
    //             reject(error);
    //         });
    //     })
    // }
    const getEndingSoonItem = () => {
        const payload = {
            "sort": [{ "field": "itemclosetime", "direction": "asc" }],
            "page": { "size": 4 },
            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime", "title", "isshippable", "saleid", "category", "categoryGroup", "thumbnailurl", "itemseourl"],
            "filter": [
                { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                // { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" },
                // {"field": "itemtypeid", "value": 1, "op": "=", "join": "OR"}, 
                // {"field": "itemtypeid","value": 2,"op": "=","join": "AND" },
            ]
        };
        return new Promise((resolve, reject) => {
            ItemsService.getItemsList(payload).then(response => {
                resolve(response.data.data);
            }).catch((error) => {
                reject(error);
            });
        })
    }
    const getBidValue = (item) => {
        const itemId = item.id ? item.id : item.itemid;
        const itemValue = currentBid.filter(x => x.itemid === itemId);
        return itemValue.length > 0 ? isNaN(itemValue[0].bidprice) ? 0 : itemValue[0].bidprice : 0;
    }
    const overAllClick = (item, index, prevNextList=[]) => {
        if ( prevNextList.length > 0 ) {
            setItemPreviousNextInSessionStorage(prevNextList, index);
        }
        let itemid = item?.id || item?.itemid
        props.history.push(getItemUrl(item.saleid, itemid, item.itemseourl))
    }

    const sellWithShop = () => {
        return <img src={contentimg} className="rightimg" alt="Sell and Shop Differently with CTBids"/>
    }

    const navigateToPlayStore = (type) => {
        if(window.innerWidth <= 1025){
            if (type == 'appstore') {
                let dataLayerData = {
                    'event': 'app_store_clicks',
                    'title': APP_STORE_URL
                }
                addDataLayer(dataLayerData);
                window.open(APP_STORE_URL, "_blank");
            } else if (type == 'googlestore') {
                let dataLayerData = {
                    'event': 'app_store_clicks',
                    'title': PLAY_STORE_URL
                }
                addDataLayer(dataLayerData);
                window.open(PLAY_STORE_URL, "_blank");
            }
        }
    }

    const openInNewTab = (link) => {
        window.open(link, '_blank');

        let dataLayerData = {
            'event': 'scmlink_clicks',
            'title': link
        }
        addDataLayer(dataLayerData);
    }
    const siginSegment = () => {
        return <div className="head">Sign up and register</div>
    }
    const showWithCtbids = () => {
        return (
            <div className="d-flex align-items-center gap-3 py-5 shop-with-ctbids-btn">
                {!isAuthorized() && <Button className="btn-secondary" onClick={() => { redirectSignin() }}>Get Started</Button>}
                <Button className="btn-grey" onClick={() => { props.history.push('/about') }}>Learn More</Button>
            </div>
        )
    }

    return (
        <div className="home-container">
              <Helmet>
                <title>CTBids</title>
            </Helmet>
            <div className="p-3 w-100">
                <div style={{ backgroundImage: `url(${homebanner.bgimage == "" ? homeBg : homebanner.bgimage})` }} className={"homebg"} alt="home-image">
                    <div className="head-cont d-flex flex-column">
                        <div>
                            <div className="head" dangerouslySetInnerHTML={{ __html: homebanner.header }}></div>
                            <div className="home-sub-head" dangerouslySetInnerHTML={{ __html: homebanner.subheader }}></div>
                            <div className="sub-head" dangerouslySetInnerHTML={{ __html: homebanner.description }}></div>
                        </div>
                        <div className="start-shopping-container">
                            <button className="head-button mt-4" style={{color: '#00263E'}} onClick={() => {
                                props.history.push({ pathname: `${homebanner?.button?.link}` });
                            }}>{homebanner?.button?.title}</button>
                        </div>
                    </div>
                    <div className="multicard" >
                        <MultiListPage
                            list={multilist}
                            renderItem={(item, index) => {
                                return (
                                    <ItemCardBoard items={item}
                                    getBidValue={getBidValue(item)}
                                    bidnow={() => { overAllClick(item, index) }}
                                />
                                )
                            }}
                            count={1}
                            screensize={2}
                        />
                    </div>
                </div>
                <SaleListHoc props={props} type={SALE_LIST_TYPE.FEATUREDSALE} isHorizontal={true} />
            </div>
            <div className="home-content">
                <div className="ctcont">
                    <div className="adcont">
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : <div>Ad container</div>}
                    </div>
                </div>
                <div className="content-state">
                    <div >
                        <div className="cont-head">Shop with a Purpose with <span className="text-navy" style={{color: '#00263E'}}>CT</span><span className="text-secondary">Bids</span></div>
                        <div className="d-flex h-100 gap-3 shop-with-ctbids">
                            <div className=" right-view">
                                <Accordion defaultActiveKey="0" activeKey={activeKey} onSelect={(key) => {
                                    if (key != null) {
                                        setActiveKey(key)
                                    }
                                }}>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Care & Compassion</Accordion.Header>
                                        <Accordion.Body>Powered by Caring Transitions, CTBids is more than a marketplace—it’s a mission in motion. As the nation’s leader in senior relocation, downsizing, and estate sale solutions, we guide families with care, understanding, and a commitment to making a lasting difference.Each auction preserves memories, connects generations, and supports families during life’s transitions.</Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Sustainable Shopping</Accordion.Header>
                                        <Accordion.Body>Transitions can have a profound impact on the environment. CTBids helps reduce that impact by rehoming cherished belongings, keeping them in use and out of landfills. Every auction empowers families to make thoughtful, sustainable choices, supports a circular economy, and contributes to a more intentional, lasting future for the communities and families we proudly serve.</Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2">
                                        <Accordion.Header>Safe & Secure</Accordion.Header>
                                        <Accordion.Body>Your trust matters. CTBids protects every transaction with encrypted payments, verified sellers, and fraud prevention tools. We prioritize your privacy and treat every order with care. With 24/7 customer support and layers of protection in place, you can shop confidently knowing your information and experience are safe, secure, and supported at all times.</Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            {windowWidth < 800 && showWithCtbids()}

                            <div className={`leftview ${accordionData[activeKey]["color"]}`}>
                                <img src={accordionData[activeKey]["img"]} alt="shop-with-ctbids" className="contentimg" />
                            </div>
                        </div>
                    </div>



                    {windowWidth > 800 && showWithCtbids()}

                </div>
                {/* <div className="content-newstate">
                    <div className="cont-head">Shop with a Purpose with <span className="text-navy">CT</span><span className="text-secondary">Bids</span></div>
                    <div className="newstate-cont">
                        <div className="content-card">
                            <img src={ctbids} className="content-image" />
                            <div className="cont-subhead">Care and Compassion</div>
                            <div className="cont-txt">Downsizing, relocating, or managing an estate? Life’s big transitions deserve trusted support. Let’s take the next step together.</div>
                        </div>
                        <div className="content-card">
                            <img src={earthImg} className="content-image" />
                            <div className="cont-subhead">Sustainable Shopping</div>
                            <div className="cont-txt">Every bid supports families, honors legacies, and helps build a more sustainable future. Shop with purpose. Make an impact.</div>
                        </div>
                        <div className="content-card">
                            <img src={shiledImg} className="content-image" />
                            <div className="cont-subhead">Safe and Secure</div>
                            <div className="cont-txt">You deserve peace of mind. From secure payments to verified sellers, every CTBids order is backed by layers of real protection.</div>
                        </div>
                    </div>
                    <div className="d-flex align-item-center gap-3 p-5">
                        <Button className="btn-secondary">Get Started</Button>
                        <Button className="btn-grey">Learn More</Button>
                    </div>
                </div> */}
                <div className="item-content">
                    <div className="bidding-text">Bidding Starts at $1</div>
                    <div className="bidding-divider"></div>

                    {trendingItem.length > 0 &&
                        <PaginationHOC
                            list={trendingItem}
                            renderItem={(item, index) => {
                                return (
                                    <div>
                                        <ItemCard items={item}
                                            currentBids={currentBid}
                                            watch={watchlist}
                                            bidnow={() => { overAllClick(item, index, trendingItem) }}
                                            recallWatchList={recallwatchlist}
                                        />
                                    </div>
                                )
                            }}
                            emptyCont={"No items available"}
                            title={"Trending Now"}
                            explore={() => {
                                props.history.push({ pathname: `/view-more-items/trending-now` });
                            }}
                            count={4}
                        />}
                    <div className="adcont">
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : <div>Ad container</div>}
                    </div>
                    {endingSoonItem.length > 0 &&
                        <PaginationHOC
                            list={endingSoonItem}
                            renderItem={(item, index) => {
                                return (
                                    <div>
                                        <ItemCard items={item}
                                            currentBids={currentBid}
                                            watch={watchlist}
                                            bidnow={() => { overAllClick(item, index, endingSoonItem) }}
                                            recallWatchList={recallwatchlist}
                                        />
                                    </div>
                                )
                            }}
                            emptyCont={"No items available"}
                            title={"Ending Soon"}
                            explore={() => {
                                props.history.push({ pathname: `/view-more-items/ending-soon` });
                            }}
                            count={4}
                        />}
                </div>
                <div className="homecard">

                    <div style={{ backgroundImage: `url(${window.innerWidth > 800 ? homeCard1 : homeCard2})`, height: window.innerWidth > 800 && '375px !impartent'   }} className={"homeCard1"} alt="home-card">
                        <div className="d-flex">
                            <div className="head-cont news-and-stories-section d-flex flex-column" style={{justifyContent: 'start'}}>
                                <div>
                                    <div className="head">News and Stories</div>
                                    <div className="home-sub-head mt-3">How to Score <br/> the Best Finds</div>
                                </div>
                                <div className="mt-3">
                                    <button className="head-button mt-5" onClick={() => props.history.push(`/stories/${NEWSANDSTORIESID}`)}>Read more</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="contentUI">
                    <div className="leftui">
                        {windowWidth < 500 && sellWithShop()}
                        <div className="leftcont">
                            <div className="cont-head">Sell and Shop Differently with <span className="text-navy">CT</span><span className="text-secondary">Bids</span></div>
                            <div className="cont-txt">CTBids is Not Just an Auction Site. We are not just buying and selling items; we are cherishing memories, connecting generations, and supporting families through challenging transitions.</div>
                        </div>
                        {windowWidth > 500 && sellWithShop()}
                    </div>
                    <div className="rightui">
                    {window.innerWidth <= 500 && <div className="p-2 fs-20 discover-text text-bold"> Discover a world of unique and everyday treasures</div>}
                        <div className="leftcont">
                            {window.innerWidth >= 500 && <div className="cont-head p-2"> Discover a world of unique and everyday treasures</div>}
                            <div>
                                <div className="d-flex key-points gap-2 p-2">
                                    <div >{cirecleTick}</div>
                                    <div className="cont-txt">Find great deals in your community & nationwide</div>
                                </div>
                                <div className="d-flex gap-2 p-2 key-points align-items-center">
                                    <div >{cirecleTick}</div>
                                    <div className="cont-txt">Real time updates and notifications</div>
                                </div>
                                <div className="d-flex gap-2 p-2 key-points align-items-center">
                                    <div >{cirecleTick}</div>
                                    <div className="cont-txt">Bidding starts at $1</div>
                                </div>
                                <div className="d-flex gap-2 p-2 key-points align-items-center">
                                    <div >{cirecleTick}</div>
                                    <div className="cont-txt">More of what you love</div>
                                </div>
                                 <div className="d-flex gap-2 my-2">
                                    <img className="appstorelogo" src={androidstore} alt='google-play-icon' onClick={() => { navigateToPlayStore('googlestore') }}  />
                                    <img className="appstorelogo" src={appstore} alt='app-store-icon'  onClick={() => { navigateToPlayStore('appstore') }}  />
                                </div>
                            </div>
                        </div>
                        <img src={iPhone14} className="rightimg" alt="Discover a world of unique and everyday treasures" />
                    </div>

                </div>
                <CategoryList history={props?.history} />
                <div className="ctcont d-flex gap-3 w-100">
                    <div className="adcont">
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : <div>Ad container</div>}
                    </div>
                    <div className="adcont">
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : <div>Ad container</div>}
                    </div>
                    <div className="adcont">
                        {ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : <div>Ad container</div>}
                    </div>
                </div>
                <div className="bottom-view">
                    <div className="treasures-text">Treasures, Stories and more @CTBids</div>
                    <div className="followlink" role={"button"} onClick={() => {
                        let dataLayerData = {
                            'event': "facebook_follow"
                        }
                        addDataLayer(dataLayerData);
                        openInNewTab('https://www.facebook.com/CTBidsOnlineAuctions')
                    }}>Follow us</div>
                </div>
                {!("id" in userData && userData?.id) && <div className="bottom-card">
                    <img src={bottomcard} alt="template-image" className="bottomcard"></img>
                    <div className="bottom-right">
                        {windowWidth > 800 && siginSegment()}
                        <div className="sub-head" style={{color: '#D9F2FF', marginTop: '5px'}}>Get all the benefits by signing up for CTBids</div>
                        {windowWidth < 800 && siginSegment()}
                        <div className="sub-text mt-4">Enhance your bidding experience through our CTBids Premier membership. From being able to win Mystery Rewards, to getting a sneak peek of upcoming sales and their items, 
                        we have benefits that are going to change the way you shop CTBids. Each individual benefit from Delivery Guarantee to Total Access has significant value, and with Premier, 
                        you get all six benefits for only $99/year.</div>
                        <button className="bottom-button" onClick={() => {
                            props.history.push('/register')
                        }}>Get started today</button>
                    </div>
                </div>}
            </div>
        </div>
    )
}